import React from "react"
import {MainCP} from "../../Components/Conocimiento-Aprobacion/MainCP"

const ViewConocimientoAprobacion: React.FC = () => <MainCP/>

export default ViewConocimientoAprobacion;